import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <Link
      to={`/works/detail/${item.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 动画海报 - age动漫作品展示`}
          title={`${item.title} - ${item.type}作品介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded bg-accent-950/80 text-background-50 text-[11px] backdrop-blur-sm">
          {item.type}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-3.5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-[11px] text-foreground-400">
          {item.year} · {item.region} · {item.episodes}
        </p>
        <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">{item.summary}</p>
        <div className="mt-3 flex items-center justify-between gap-2 text-[11px] text-foreground-400 min-w-0">
          <span className="flex items-center gap-1 text-primary-600 shrink-0">
            <i className="ri-heart-3-line"></i>
            {item.favoriteCount.toLocaleString("zh-CN")}
          </span>
          <span className="truncate">{item.studio}</span>
        </div>
      </div>
    </Link>
  );
}